export default __webpack_public_path__ + "static/media/floor-10.6c5dd0e9.jpg";